import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SignIn, SignUp, SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import EnhancedKYBInterface from './components/EnhancedKYBInterface';
import './styles/globals.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes - Login/Signup */}
        <Route 
          path="/sign-in/*" 
          element={
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
              <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
            </div>
          } 
        />
        <Route 
          path="/sign-up/*" 
          element={
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
              <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
            </div>
          } 
        />

        {/* Protected route - Main app */}
        <Route 
          path="/" 
          element={
            <>
              <SignedIn>
                <div className="relative">
                  {/* User profile button in top-right corner */}
                  <div className="absolute top-4 right-4 z-50">
                    <UserButton 
                      appearance={{
                        elements: {
                          avatarBox: "w-10 h-10"
                        }
                      }}
                    />
                  </div>
                  <EnhancedKYBInterface />
                </div>
              </SignedIn>
              <SignedOut>
                <Navigate to="/sign-in" replace />
              </SignedOut>
            </>
          } 
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;